module.exports = __webpack_public_path__ + "img/is.a2771303.svg";